(function() {
    function initBestSeller(root) {
        if (!root) return;

        const configEl = root.querySelector('[data-bs-config]');
        if (!configEl) return;
        let config = {};
        try {
            config = JSON.parse(configEl.innerHTML);
        } catch (e) {
            console.error('Best Seller Carousel config error:', e);
        }

        const viewport = root.querySelector('.bs-slider-viewport');
        const prevBtn = root.querySelector('.bs-prev');
        const nextBtn = root.querySelector('.bs-next');

        if (!viewport || !prevBtn || !nextBtn) return;

        function getScrollAmount() {
            const card = viewport.querySelector('.bs-card');
            if (card) {
                return card.offsetWidth + 20; // card width + gap
            }
            return viewport.offsetWidth * 0.8;
        }

        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            viewport.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });

        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });

        // Hide arrows if not scrollable and Update button states
        function updateCarouselUI() {
            const isScrollable = viewport.scrollWidth > (viewport.clientWidth + 1);
            const arrows = root.querySelector('.bs-arrows');
            if (arrows) {
                arrows.style.display = isScrollable ? 'flex' : 'none';
            }

            // Disable prev if at start
            prevBtn.disabled = viewport.scrollLeft <= 5;
            // Disable next if at end
            nextBtn.disabled = (viewport.scrollLeft + viewport.offsetWidth) >= (viewport.scrollWidth - 5);
        }

        viewport.addEventListener('scroll', updateCarouselUI);
        window.addEventListener('resize', updateCarouselUI);

        // Optional: Manual Scroll / Dragging
        let isDown = false;
        let startX;
        let scrollLeft;

        viewport.addEventListener('mousedown', (e) => {
            if (!config.manualScroll) return;
            isDown = true;
            viewport.classList.add('is-dragging');
            startX = e.pageX - viewport.offsetLeft;
            scrollLeft = viewport.scrollLeft;
        });

        window.addEventListener('mouseup', () => {
            isDown = false;
            viewport.classList.remove('is-dragging');
        });

        window.addEventListener('mouseleave', () => {
            isDown = false;
            viewport.classList.remove('is-dragging');
        });

        viewport.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - viewport.offsetLeft;
            const walk = (x - startX) * 2;
            viewport.scrollLeft = scrollLeft - walk;
        });

        // Autoplay
        let autoplayInterval;
        function startAutoplay() {
            if (!config.autoplay) return;
            autoplayInterval = setInterval(() => {
                if ((viewport.scrollLeft + viewport.offsetWidth) >= (viewport.scrollWidth - 10)) {
                    viewport.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
                }
            }, config.autoplaySpeed);
        }

        function stopAutoplay() {
            clearInterval(autoplayInterval);
        }

        if (config.autoplay) {
            startAutoplay();
            viewport.addEventListener('mouseenter', stopAutoplay);
            viewport.addEventListener('mouseleave', startAutoplay);
            viewport.addEventListener('touchstart', stopAutoplay);
        }

        // Initial check after everything is rendered
        setTimeout(updateCarouselUI, 200);
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-bs-root]').forEach(initBestSeller);
    });

    document.addEventListener('shopify:section:load', (e) => {
        const root = e.target.querySelector('[data-bs-root]');
        if (root) initBestSeller(root);
    });
})();
